<template>
  <div class="panelContent">
    <div class="row center-xs">
      <div v-if="panel.title && panel.title.text" class="col-xs-12 mar-b20">
        <span class="textLarge" :style="{'font-size': panel.autofit ? (panel.width * 0.3) + 'vw' : panel.title.size + 'px', color: panel.title.colour}">{{panel.title.text}}</span>
      </div>
      <div class="col-xs-12">
        <component :is="chartType" :chart-data="chartData" :options="chartOptions" :height="height" :style="{height: height - 100 + 'px', position: 'relative', width: '90%', left: '5%'}"></component>
      </div>
    </div>
  </div>
</template>

<script>
import Bar from "./charts/Bar";
import Doughnut from "./charts/Doughnut";
import LineChart from "./charts/Line";
import Pie from "./charts/Pie";
import colours from "../../../utils/colours";
export default {
  components: { Bar, Doughnut, LineChart, Pie },
  props: ["panel", "data", "definition", "height"],
  data() {
    return {
      chartType: undefined,
      chartData: {
        datasets: [
          {
            data: [],
            label: ""
          }
        ],
        labels: []
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false
        },
        legend: {
          labels: {
            fontColor: this.panel.backgroundColour === "white" ? "black" : "white"
          }
        }
      }
    };
  },
  created() {
    this.getType();
  },
  watch: {
    "panel.graphType": function(val) {
      this.getType(val);
    },
    data: {
      handler: function(val) {
        this.getData(val);
      },
      deep: true
    },
    "panel.backgroundColour": function(val) {
      if (val === "white") {
        this.chartOptions.legend.labels.fontColor = "black";
      }
    }
  },
  methods: {
    getType(val) {
      switch (val || this.panel.graphType) {
        case "pie":
          this.chartType = "Pie";
          break;
        case "bar":
        case "stackedbar":
          this.chartType = "Bar";
          break;
        case "line":
          this.chartType = "LineChart";
          break;
        case "doughnut":
          this.chartType = "Doughnut";
          break;
      }
      this.getOptions();
    },
    getOptions() {
      var obj = {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false
        },
        legend: {
          position: "bottom",
          labels: {
            fontColor: this.panel.backgroundColour === "white" ? "black" : "white"
          }
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
                drawBorder: false
              },
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      };

      if (this.panel.graphType === "bar") {
        obj.legend.display = false;
      }

      if (this.panel.graphType === "pie" || this.panel.graphType === "doughnut") {
        delete obj.scales;
      }

      if (this.panel.graphType === "stackedbar") {
        obj.scales.xAxes[0].stacked = true;
        obj.scales.yAxes[0].stacked = true;
      }

      this.chartOptions = obj;
    },
    getData(val) {
      let data = val;
      switch (this.panel.graphType) {
        case "pie":
        case "doughnut":
        case "bar":
          this.chartData = this.processPie(data);
          break;
        case "stackedbar":
          this.chartData = this.processStackedBar(data);
          break;
        case "line":
          this.chartData = this.processLine(data);
          break;
      }
    },
    processPie(data) {
      var obj = {
        datasets: [
          {
            data: [],
            backgroundColor: [],
            label: ""
          }
        ],
        labels: []
      };

      data[0].dataValues.forEach((row, index) => {
        obj.labels.push(row.label);
        obj.datasets[0].data.push(row.value);
        obj.datasets[0].backgroundColor.push(colours.charts[index]);
      });

      return obj;
    },
    processStackedBar(data) {
      let obj = {
        labels: [],
        datasets: []
      };

      data.forEach((group, index) => {
        let dataset = {
          label: group.name,
          backgroundColor: colours.charts[index],
          data: []
        };
        group.dataValues.forEach((row, subIndex) => {
          if (!index) {
            dataset.data.push(row.value);
            obj.labels.push(row.label);
          }
          let foundIndex = obj.labels.indexOf(row.label);
          if (foundIndex) {
            dataset.data[foundIndex] = row.value;
          } else {
            dataset.data[subIndex] = row.value;
          }
        });
        obj.datasets.push(dataset);
      });

      return obj;
    },
    processLine(data) {
      let obj = {
        labels: [],
        datasets: []
      };

      data.forEach((group, index) => {
        let dataset = {
          label: group.name,
          backgroundColor: colours.charts[index],
          borderColor: colours.charts[index],
          fill: false,
          data: []
        };
        group.dataValues.forEach((row, subIndex) => {
          if (!index) {
            dataset.data.push(row.value);
            obj.labels.push(row.label);
          }
          let foundIndex = obj.labels.indexOf(row.label);
          if (foundIndex) {
            dataset.data[foundIndex] = row.value;
          } else {
            dataset.data[subIndex] = row.value;
          }
        });
        obj.datasets.push(dataset);
      });

      return obj;
    }
  }
};
</script>

<style>
</style>
